import React from "react";
import { Row } from "reactstrap";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

import Highlight from "../components/Highlight";

const ProfileUser = () => {
  const { user } = useAuth0();

  return (
    <>
      <h3>User</h3>
      <Row>
        <Highlight>{JSON.stringify(user, null, 2)}</Highlight>
      </Row>
    </>
  )
};

export default withAuthenticationRequired(ProfileUser);